import { Subject, merge } from 'rxjs'
import { Online } from 'front-end-core/services/WindowService'

const InstantSearchStream = new Subject()
const Abort = new Subject()

export const clear = function () {
  Abort.next([])
}

merge(Abort, Online)
  .forEach(() => InstantSearchStream.next([]))
